import { isRoleUtil } from "../../utils/roleAliases";

export const isAdmin = (roleList) => {
  return isRoleUtil("ADMIN", roleList);
};

export const isGeneralManagment = (roleList) => {
  return isRoleUtil("GENERAL_MANAGEMENT", roleList);
};